export default "__VITE_ASSET__8c084088__"